/*-- Focus --*/

.bb-target {
  &.bb-focused {
    opacity: 1;
  }

  &.bb-focused {
    path.bb-line,
    path.bb-step {
      stroke-width: 2px;
    }
  }

  &.bb-defocused {
    opacity: 0.3 !important;

    .text-overlapping {
      opacity: 0.05 !important;
    }
  }
}

text.bb-chart-arcs-title {
  transform: translate(0px, 15px);
  cursor: default;

  tspan:first-of-type {
    font-weight: 400;
    font-size: var(--header-font-size-large);
  }

  tspan:not(:first-of-type) {
    font-size: var(--body-size-large);
  }
}

#generalDonutChartContainer {
  width: 100%;
  padding-top: calc(var(--spacer) * 2);

  #legend-content {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-left: calc(var(--spacer) * 1.5);
      display: flex;
      align-items: center;
      margin-bottom: var(--spacer);
      .legend {
        &-title {
          color: var(--body-text-arrows-400);
        }
        &-value {
          color: var(--main-titles-inputs-600);
        }
      }
      span {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-right: var(--spacer);
      }
    }

    .legend {
      &-title {
        font-size: var(--body-size-large);
      }
      &-value {
        margin-left: calc(var(--spacer) * 2);
        font-size: var(--body-size-large);
        font-weight: bold;
      }
    }
  }

  #chart-content {
    width: inherit;
    height: inherit;
    display: block;
    align-items: center;
    justify-content: center;

    .bb-chart text :first-child {
      font-size: var(--body-size);
      fill: var(--main-titles-inputs-600);
    }

    .bb-chart text :nth-child(3) {
      font-size: var(--body-size-large);
      font-weight: bold;
    }

    .bb-chart-arcs-title {
      fill: var(--main-titles-inputs-600);
    }

    .bb-chart-arcs-title tspan:first-child {
      font-size: var(--general-donut-chart-value);
      fill: var(--main-titles-inputs-600);
    }

    .bb-chart-arcs-title tspan:nth-child(2) {
      font-size: var(--general-donut-chart-label);
      fill: var(--main-titles-inputs-600);
      font-weight: normal;
    }

    .bb-chart text {
      margin: 30px;
    }

    .bb-chart {
      padding-bottom: 10px;
    }
  }
  &.resized {
    padding-top: calc(var(--spacer) * 2.5);
  }
}
